import React, { useCallback, useEffect, useState } from "react";
import MultiSelect from "../../components/MultiSelect";
import { Option } from "../../interfaces/MultiSelectTypes";
import { Visit } from "../../interfaces/Visit";
import { updateField } from "../../utils/StateUtil";
import { useAppDispatch } from "../../hooks";
import { getMedicines } from "../../apis/medicine";
import { debounce } from "lodash";

import { Medicine } from "../../interfaces/Medicine";
type MedicineSelectProps = {
  visit: Visit;
  onMedicineCreate: (value: string) => void;
};
const MedicineSelect: React.FC<MedicineSelectProps> = ({
  visit,
  onMedicineCreate,
}) => {
  const [medicines, setMedicines] = useState<Array<Medicine>>([]);

  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchMedicines();
  }, []);

  const handleSearch = (search: string) => {
    debouncedFetchMedicines(search);
  };

  const debouncedFetchMedicines = useCallback(
    debounce((query) => fetchMedicines(query), 500), // 300ms delay
    []
  );

  const fetchMedicines = async (search: string = "") => {
    try {
      const restrictToPharmacy = window.localStorage.getItem("restrictPrescriptionsToPharmacy") === "yes";
      const params: any = { name: search, autocomplete: true };
      if (restrictToPharmacy) params.restrict_to_pharmacy = true;
      const {
        data: { data: response },
      } = await getMedicines(params);
      setMedicines(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMedicineSelect = (option: Option) => {
    if (
      !visit.medicines.some(
        (selected) => selected?.id && selected.id.toString() === option.value
      )
    ) {
      const [medicine] = medicines.filter(
        (medicine) => medicine.id.toString() === option.value
      );

      updateField(
        "medicines",
        [
          ...visit.medicines,
          {
            id: option.value,
            name: option.label,
            instructions: {
              name: option.label,
              molecule: medicine.molecule,
              form: medicine.form,
              morning: "",
              afternoon: "",
              evening: "",
              night: "",
              meal: "before_meal",
              note: "",
              quantity: 0,
              frequency: "daily",
              duration: "",
              power: "",
              unit: "",
              dosage: "",
              durationPeriod: "days",
            },
          },
        ],
        dispatch
      );
    }
  };

  const handleMedicineRemoval = (option: Option) => {
    const updatedMedicines = visit.medicines.filter(
      (selected) => selected?.id && selected.id.toString() !== option.value
    );
    updateField("medicines", updatedMedicines, dispatch);
  };

  return (
    <div className="block">
      <label className="block text-sm font-medium leading-6 text-gray-900">
        Medicines
      </label>
      <MultiSelect
        onAddNewOption={(label) => onMedicineCreate(label)}
        selectedOptions={visit.medicines.map((i: any) => ({
          label: i.name,
          value: i?.id.toString(),
        }))}
        options={medicines.map((i) => ({
          label: i.name,
          value: i.id.toString(),
        }))}
        onSearch={handleSearch}
        onOptionSelect={handleMedicineSelect}
        onOptionRemove={handleMedicineRemoval}
      />
    </div>
  );
};

export default MedicineSelect;
